var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99988 19C5.99988 19.5304 6.21059 20.0391 6.58566 20.4142C6.96074 20.7893 7.46944 21 7.99988 21H15.9999C16.5303 21 17.039 20.7893 17.4141 20.4142C17.7892 20.0391 17.9999 19.5304 17.9999 19V7H5.99988V19ZM7.99988 9H15.9999V19H7.99988V9ZM15.4999 4L14.4999 3H9.49988L8.49988 4H4.99988V6H18.9999V4H15.4999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.cff5b9d555972aa5a51727a48e3ba46c.svg";
export { ForwardRef as ReactComponent };